import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 导入vant核心组件
import { 
  Button, 
  Cell, 
  CellGroup, 
  Icon, 
  Tabbar, 
  TabbarItem, 
  NavBar,
  Form,
  Field,
  Toast,
  Dialog,
  Notify,
  Card,
  Tag,
  Divider,
  Grid,
  GridItem,
  Image as VanImage,
  List,
  PullRefresh,
  Tab,
  Tabs,
  Popup,
  DatetimePicker,
  Picker,
  Uploader,
  Empty,
  Loading,
  Search,  // 添加 Search 组件
  DropdownMenu,  // 添加 DropdownMenu 组件
  DropdownItem   // 添加 DropdownItem 组件
} from 'vant';

// 注册组件
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);
Vue.use(Form);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Notify);
Vue.use(Card);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(VanImage);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Empty);
Vue.use(Loading);
Vue.use(Picker);
Vue.use(Search);  // 注册 Search 组件
Vue.use(DropdownMenu);  // 注册 DropdownMenu 组件
Vue.use(DropdownItem);  // 注册 DropdownItem 组件

// 移动端适配
import 'amfe-flexible';

// 导入API服务
import api from './api'
Vue.prototype.$api = api

// 路由守卫
router.beforeEach((to, from, next) => {
  // 判断是否需要登录
  if (to.meta.requiresAuth && !store.state.isLoggedIn) {
    next('/login');
  } else {
    next();
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
